import { iConfig } from '@/config/config-models';

export const config: iConfig = {
	apiBaseUrl: 'https://backend-dev.cobalt.care/',
	providerManagementFeature: false,
	downForMaintenance: false,

	gaTrackingId: undefined,
	ga4MeasurementId: undefined,
	mixPanelId: undefined,

	showDebug: false,

	localhostSubdomain: undefined,

	authRedirectUrls: [],
	storageKeys: {
		mhicRecentOrdersStorageKey: 'mhicRecentOrders',
		chunkloadRefreshKey: 'ChunkLoadError-refresh',
	},
};

export default config;
